/**
 * Background video plugin
 * Created by gianluca on 25-12-15.
 */

;(function ($, window) {
    $.fn.backgroundvideo = function (pluginOptions) {

        var defaults = {
            ratio: 16 / 9,
            videoId: '116244713', // youtube or vimeo // 116244713 // HfrvPOmXFOE
            mute: true,
            repeat: true,
            width: $(window).width(),
            start: 0,
            end: false,
            videoQuality: 'hd1080',
            relatedVideos: 0,
            wrapperZindex: 99
        };

        var options                 = $.extend({}, defaults, pluginOptions);
        var body                    = $('body');
        var node                    = $('node');
        var provider                = '';
        var readyEventDispatched    = false;
        var vimeoTime               = 0;

        var obj = {
            init: function () {
                var _this = this;
                this.buildContainer();
                this.determineProvider();

                 $(window).on('resize.backgroundvideo', this.resize);
            },
            buildContainer: function () {
                var backgroundContainer = '' +
                    '<div id="background-container"style="overflow: hidden; position: fixed; z-index: 1; width: 100%; height: 100%">' +
                    '<div id="background-player" style="position: absolute"></div>' +
                    '</div>';

                $('html, body').css({'width': '100%', 'height': '100%'});

                body.prepend(backgroundContainer);
                node.css({position: 'relative', 'z-index': options.wrapperZindex});
            },
            determineProvider: function () {
                var a  = document.createElement('a');
                a.href = options.videoId;

                if (/youtube.com/.test(options.videoId)) {
                    this.setupYoutube();
                }
                else if (/vimeo.com/.test(options.videoId)) {
                    setupVimeo();
                }
                else if (/[-A-Za-z0-9_]+/.test(options.videoId)) {

                    var id = new String(options.videoId.match(/[-A-Za-z0-9_]+/));

                    if (id.length == 11) {
                        this.setupYoutube();
                    }

                    else {
                        this.setupVimeo();
                    }
                }
                else {
                    throw 'backgroundVideo: Invalid video source';
                }
            },
            setupYoutube: function () {
                provider = 'youtube';

                window.onYouTubeIframeAPIReady = function () {
                    window.player = new YT.Player('background-player', {
                        width: options.width,
                        height: Math.ceil(options.width / options.ratio),
                        videoId: options.videoId,
                        playerVars: {
                            controls: 0,
                            showinfo: 0,
                            modestbranding: 1,
                            iv_load_policy: 3,
                            wmode: 'transparent',
                            vq: options.videoQuality,
                            rel: options.relatedVideos,
                            end: options.end,
                            start: options.start,
                            autoplay: true
                        },
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                };

                // events
                window.onPlayerReady = function (e) {
                    obj.resize();
                    if (options.mute) {
                        e.target.mute()
                    }
                };

                window.onPlayerStateChange = function (state) {
                    if (state.data == 1 && readyEventDispatched == false) {
                        options.callback();
                        readyEventDispatched = true;

                    } else if (state.data === 0 && options.repeat) {
                        player.seekTo(0);

                    }
                };

                // load youtube iframe js api
                this.addScript('https://www.youtube.com/iframe_api');
            },
            setupVimeo: function () {
                provider = 'vimeo';

                var _this = this;

                $('#background-player')
                    .replaceWith(function () {
                        var url = '//player.vimeo.com/video/' + options.videoId + '?api=1&title=0&byline=0&portrait=0&playbar=0&loop=' + options.repeat + '&autoplay=1&player_id=background-player';
                        return '<iframe src="' + url + '" frameborder="0" id="background-player"></iframe>';
                    });

                this.resize();

                $('#background-player').on('load', function () {
                    // load froogaloop
                    _this.addScript('//origin-assets.vimeo.com/js/froogaloop2.min.js', _this.vimeoReady);
                });
            },
            vimeoReady: function () {
                var iframe       = $('#background-player')[0];
                
                window.player = $f(iframe);
                window.player.api('setVolume', 0);
                window.player.api('seekTo', options.start);

                player.addEvent('playProgress', function(data) {
                    vimeoTime = Math.floor(data.seconds);
                });

                if (readyEventDispatched == false) {
                    var timeout = 1000;
                    setTimeout(function() {
                        options.callback();
                        readyEventDispatched = true;
                    }, timeout);
                }
            },
            addScript: function (source, callback) {
                var tag = document.createElement('script');

                if (callback) {
                    if (tag.readyState) {  //IE
                        tag.onreadystatechange = function () {
                            if (tag.readyState === "loaded" ||
                                tag.readyState === "complete") {
                                tag.onreadystatechange = null;
                                callback();
                            }
                        };
                    } else {
                        tag.onload = function () {
                            callback();
                        };
                    }
                }

                tag.src            = source;
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            },

            getProgress: function() {
                if (provider == 'youtube') {
                    return Math.floor(window.player.getCurrentTime());

                } else if (provider == 'vimeo') {
                    return vimeoTime;
                }
            },
            resize: function () {

                // Handles the resizing. Positions video
                var width  = $(window).width(),
                    height = $(window).height(),
                    playerWidth,
                    playerHeight,
                    player = $('#background-player');

                if (width / options.ratio < height) {

                    playerWidth = Math.ceil(height * options.ratio);
                    player.width(playerWidth)
                        .height(height)

                        .css({
                            'left': (width - playerWidth) / 2,
                            'top': 0
                        });

                } else {

                    playerHeight = Math.ceil(width / options.ratio);
                    player.width(width)
                        .height(playerHeight)

                        .css({
                            'left': 0,
                            'top': (height - playerHeight) / 2
                        });
                }
            }
        };

        obj.init();
        return obj;
    };

})(jQuery, window);